import { render, staticRenderFns } from "./FooterGlobal.vue?vue&type=template&id=58c18630&scoped=true&"
import script from "./FooterGlobal.vue?vue&type=script&lang=js&"
export * from "./FooterGlobal.vue?vue&type=script&lang=js&"
import style0 from "./FooterGlobal.vue?vue&type=style&index=0&id=58c18630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c18630",
  null
  
)

export default component.exports